import reducer from './reducers';

export { default as summariesSelectors } from './selectors';
export { default as summariesOperations } from './operations';
export { default as summariesTypes } from './types';

export default reducer;
